exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".p-postEditor__point__desc[data-v-204218d4]{white-space:pre-line;word-wrap:break-word}", "", {"version":3,"sources":["/home/circleci/repo/app/components/postEditor/items/previews/PointItemPreview.vue"],"names":[],"mappings":"AAkFA,4CACE,qBACA,oBAAA,CAAA","file":"PointItemPreview.vue?vue&type=style&index=0&id=204218d4&scoped=true&lang=sass&","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.p-postEditor__point__desc\n  white-space: pre-line\n  word-wrap: break-word\n"],"sourceRoot":""}]);

// exports
